import { render, staticRenderFns } from "./WaterQualityDashboard.vue?vue&type=template&id=ba02534a&scoped=true&"
import script from "./WaterQualityDashboard.vue?vue&type=script&lang=js&"
export * from "./WaterQualityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WaterQualityDashboard.vue?vue&type=style&index=0&id=ba02534a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba02534a",
  null
  
)

export default component.exports